<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews" :exclude="exclude">
        <router-view v-if="refresh" :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  data() {
    return {
      refresh: true,
      exclude: null,
    };
  },
  methods: {
    refreshView(name) {
      //隐藏组件
      this.refresh = false;
      //增加排除
      this.exclude = name;
      this.$nextTick((_) => {
        //删除排除
        this.exclude = null;
        //显示组件
        this.refresh = true;
      });
    },
  },
  computed: {
    cachedViews() {
      //console.log("///",this.$store.state.tags.cachedViews)
      return this.$store.state.tags.cachedViews;
    },
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    // min-height: calc(100vh - 84px);
    min-height: 100vh;
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
